import { cn } from "cy-fe/src/utils/cn";

export function PageContentContainer({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={cn("mx-auto max-w-2xl", className)}>{children}</div>;
}
